import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const patiantSuggestionService = (formData) => {
    return axiosInstance.post(`healthcare_providers/investigation/suggestion`, formData);
}

export const patiantInvoiceService = (id) => {
    return axiosInstance.get(`healthcare_providers/investigation/invoices/${id}`);
}

export const uploadInvoiceService = (formData) => {
    return axiosInstance.post(`healthcare_providers/investigation/upload-reports`, formData);
}